/**
 * 1. Facebook Leads AUDI
 * Activación: utm_source=facebook | fb | facebook_leads
 */
export const FUENTE_FACEBOOK_LEADS = {
  fuenteSitioWeb: 'Facebook Leads AUDI',
  fuenteSecundaria: 'Medios Digitales Importador',
  tercerNivel: 'Preventa conquista',
  tipoRegistro: 'Importador',
  marca: 'Audi',
};

/**
 * 2. TikTok
 * Activación: utm_source=tiktok | tt
 */
export const FUENTE_TIKTOK = {
  fuenteSitioWeb: 'TikTok',
  fuenteSecundaria: 'Medios Digitales Importador',
  tercerNivel: 'Preventa conquista',
  tipoRegistro: 'Importador',
  marca: 'Audi',
};

/**
 * 3. Proveedor
 * Activación: utm_medium=[proveedor válido]
 * tipoCita se asigna dinámicamente según el proveedor
 */
export const FUENTE_PROVEEDOR = {
  fuenteSitioWeb: 'Proveedor',
  fuenteSecundaria: 'Medios Digitales Importador',
  tercerNivel: 'Preventa conquista',
  tipoRegistro: 'Importador',
  marca: 'Audi',
};

/**
 * 4. Sitio Web Audi – Preventa Conquista
 * Activación: Default para formularios conquista sin UTMs específicos
 */
export const FUENTE_SITIO_WEB_CONQUISTA = {
  fuenteSitioWeb: 'Sitio Web Audi',
  fuenteSecundaria: 'Correo electrónico Importador',
  tercerNivel: 'Preventa conquista',
  tipoRegistro: 'Importador',
  marca: 'Audi',
};

/**
 * 5. Sitio Web Audi – Preventa Lealtad
 * Activación: Default para formularios lealtad sin UTMs específicos
 */
export const FUENTE_SITIO_WEB_LEALTAD = {
  fuenteSitioWeb: 'Sitio Web Audi',
  fuenteSecundaria: 'Correo electrónico Importador',
  tercerNivel: 'Preventa lealtad',
  tipoRegistro: 'Importador',
  marca: 'Audi',
};

/**
 * 6. Prospecto Digital FS – Preventa Lealtad
 * Activación: utm_source=prospecto_fs | financiera | fs (en formulario lealtad)
 */
export const FUENTE_PROSPECTO_FS_LEALTAD = {
  fuenteSitioWeb: 'Prospecto Digital FS',
  fuenteSecundaria: 'Medios Digitales Importador',
  tercerNivel: 'Preventa lealtad',
  tipoRegistro: 'Importador',
  marca: 'Audi',
};

/**
 * 7. Prospecto Digital FS – Preventa Conquista
 * Activación: utm_source=prospecto_fs | financiera | fs (en formulario conquista)
 */
export const FUENTE_PROSPECTO_FS_CONQUISTA = {
  fuenteSitioWeb: 'Prospecto Digital FS',
  fuenteSecundaria: 'Medios Digitales Importador',
  tercerNivel: 'Preventa conquista',
  tipoRegistro: 'Importador',
  marca: 'Audi',
};

/**
 * Lista de proveedores válidos
 * El key se busca en utm_medium, el value se asigna a tipoCita
 */
export const proveedoresMapping = [
  { key: 'arkeero', value: 'Arkeero' },
  { key: 'usmedia', value: 'USMedia' },
  { key: 'antevenio', value: 'Antevenio' },
  { key: 'notonlymedia', value: 'NOM1' },
  { key: 'plm', value: 'PLM' },
  { key: 'linkstudio', value: 'Linkstudio' },
  { key: 'latamconnec', value: 'Latam Connect' },
  { key: 'leadgenios', value: 'LeadGenios' },
  { key: 'aluna', value: 'Aluna' },
];

/**
 * Configuración default cuando no hay UTMs específicos
 */
export const defaultConfigByFormType = {
  lealtad: {
    fuenteSitioWeb: 'Sitio Web Audi',
    fuenteSecundaria: 'Medios Digitales Importador',
    tercerNivel: 'Preventa lealtad',
    tipoRegistro: 'Importador',
    marca: 'Audi',
  },
  conquista: {
    fuenteSitioWeb: 'Sitio Web Audi',
    fuenteSecundaria: 'Medios Digitales Importador',
    tercerNivel: 'Preventa conquista',
    tipoRegistro: 'Importador',
    marca: 'Audi',
  },
};

/**
 * Resuelve la configuración de campaña basada en UTMs y tipo de formulario
 * @param {string} formType - Tipo de formulario: 'lealtad' | 'conquista' | 'nuevo'
 * @param {object} utms - Objeto con parámetros UTM { utm_source, utm_medium, utm_id, ... }
 * @returns {object} Configuración de campaña a aplicar al lead
 */
export const resolvePreventaQ3Config = (formType, utms) => {
  const utmSource = utms?.utm_source?.toLowerCase() || '';
  const utmMedium = utms?.utm_medium?.toLowerCase() || '';

  // Facebook
  if (utmSource.includes('facebook') || utmSource === 'fb') {
    return {
      ...FUENTE_FACEBOOK_LEADS,
      source: 'utm_source_facebook'
    };
  }

  // TikTok
  if (utmSource.includes('tiktok') || utmSource === 'tt') {
    return {
      ...FUENTE_TIKTOK,
      source: 'utm_source_tiktok'
    };
  }

  // Prospecto Digital FS (depende del formType para tercerNivel)
  if (utmSource.includes('prospecto') || utmSource.includes('financiera') || utmSource === 'fs') {
    const config = formType === 'lealtad'
      ? FUENTE_PROSPECTO_FS_LEALTAD
      : FUENTE_PROSPECTO_FS_CONQUISTA;
    return {
      ...config,
      source: 'utm_source_prospecto_fs'
    };
  }

  //Correo electrónico
  if (utmSource === 'Salesforce' && utmMedium === 'email') {
    const config = formType === 'lealtad'
      ? FUENTE_SITIO_WEB_LEALTAD
      : FUENTE_SITIO_WEB_CONQUISTA;
    return {
      ...config,
      source: 'utm_source_salesforce'
    };
  }

  // Proveedor
  if (utmSource === 'phd' && utmMedium) {
    const proveedorMatch = proveedoresMapping.find(p => utmMedium.includes(p.key));
    if (proveedorMatch) {
      return {
        ...FUENTE_PROVEEDOR,
        tipoCita: proveedorMatch.value,
        source: 'utm_medium_proveedor',
      };
    }
  }

  return {
    ...defaultConfigByFormType[formType],
    source: 'default',
  };
};